/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Bullet_ListInputs */

const en_common_editor_bullet_list = /** @type {(inputs: Common_Editor_Bullet_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bullet list`)
};

const zh_common_editor_bullet_list = /** @type {(inputs: Common_Editor_Bullet_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无序列表`)
};

/**
* | output |
* | --- |
* | "Bullet list" |
*
* @param {Common_Editor_Bullet_ListInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_bullet_list = /** @type {((inputs?: Common_Editor_Bullet_ListInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Bullet_ListInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_bullet_list(inputs)
	return zh_common_editor_bullet_list(inputs)
});
export { common_editor_bullet_list as "common.editor.bullet_list" }